export default __webpack_public_path__ + "static/media/Toparrow.572424f0.svg";